import { render, staticRenderFns } from "./the-footer.vue?vue&type=template&id=2c6ff8f8&scoped=true&"
import script from "./the-footer.vue?vue&type=script&lang=js&"
export * from "./the-footer.vue?vue&type=script&lang=js&"
import style0 from "./the-footer.vue?vue&type=style&index=0&id=2c6ff8f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ff8f8",
  null
  
)

export default component.exports